import { useEffect, useRef, useState } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import ReportService from '../../services/ReportService';
import ProductService from '../../services/ProductService';
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";

export default function CriticalStockPage() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [mounted, setMounted] = useState(false);
    const toast = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        setMounted(true);
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await ReportService.getCriticalStockReport();
            if (res.data.success) {
                setData(res.data.data);
            }
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Veriler yüklenemedi' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handlePurchaseNavigate = (product) => {
        if (!product) return;

        if (!product.lastPurchaseSupplierId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Tedarikçi Bulunamadı',
                detail: 'Bu ürün için daha önce bir alış kaydı bulunmadığından otomatik tedarikçi seçimi yapılamıyor.'
            });
            return;
        }

        navigate('/suppliers/purchase', {
            state: {
                supplierId: product.lastPurchaseSupplierId,
                supplierName: product.lastPurchaseSupplierName
            }
        });
    };

    const stockBodyTemplate = (rowData) => {
        const threshold = rowData.criticalStockQuantity || 10;
        const percentage = Math.min((rowData.stockQuantity / (threshold * 2)) * 100, 100);
        let color = 'bg-rose-500';
        if (percentage > 50) color = 'bg-amber-500';

        return (
            <div className="w-full">
                <div className="flex justify-between mb-2">
                    <span className="text-[11px] font-black text-slate-700">{rowData.stockQuantity} {rowData.unit}</span>
                    <span className="text-[10px] font-bold text-slate-400">Kritik: {threshold} {rowData.unit}</span>
                </div>
                <div className="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden">
                    <div className={`h-full ${color} transition-all duration-1000`} style={{ width: `${percentage}%` }} />
                </div>
            </div>
        );
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-end">
                <Button
                    label="TEDARİK ET"
                    icon="pi pi-shopping-cart"
                    className="!bg-emerald-600 border-none rounded-xl font-black text-[12px] px-4 py-2 shadow-lg shadow-emerald-100"
                    onClick={(e) => {
                        e.stopPropagation();
                        handlePurchaseNavigate(rowData);
                    }}
                />
                <Button
                    icon="pi pi-search"
                    className="!bg-blue-700 px-6 py-3  text-white p-button-text text-[12px]  text-slate-400 shadow-emerald-100 hover:!bg-blue-500"
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/products/detail/${rowData.id}`);
                    }}
                />
            </div>
        );
    };

    const header = (
        <div className="p-4 flex items-center justify-between bg-rose-50/30">
            <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-rose-700 animate-ping" />
                <h2 className="text-sm font-black text-slate-600 uppercase tracking-widest m-2">ACİL SİPARİŞ LİSTESİ</h2>
            </div>
            <span className="text-[11px] font-bold text-slate-400 uppercase">{data.length} Ürün Eşik Değerin Altında</span>
        </div>
    );
 const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    productName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    categoryName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    stockQuantity: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
    salePrice: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
    recordStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
     const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
  };
   const renderHeader = () => {
      return (
        <div className="flex justify-between items-center px-4 py-2 bg-slate-50 border-b border-slate-200">
          <span className="p-input-icon-left w-full md:w-80">
            <i className="pi pi-search text-slate-400 ml-3" />
            <InputText
              value={filters["global"].value || ""}
              onChange={onGlobalFilterChange}
              placeholder="Hızlı ürün ara..."
              className="w-full rounded-xl border-slate-200 text-sm  py-2 pl-10"
            />
          </span>
          <div className="flex gap-2">
             <Button
              type="button"
              icon="pi pi-filter-slash"
              label="Temizle"
              className="p-button-outlined p-button-secondary p-button-sm rounded-xl ml-3"
              onClick={() => setFilters({ 
               global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                productName: { value: null, matchMode: FilterMatchMode.CONTAINS },
                categoryName: { value: null, matchMode: FilterMatchMode.CONTAINS },
                stockQuantity: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
                salePrice: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL },
                recordStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
              })}
            />
          </div>
        </div>
      );
    };


    return (
        <div className="p-2 md:p-4 bg-white border border-slate-100 rounded-[3rem] shadow-2xl shadow-indigo-400 animate-fade-in ">
            <Toast ref={toast} appendTo={mounted ? document.body : 'self'} />

            <div className="flex flex-col md:flex-row items-center justify-between mb-12 gap-6">
                <div className="flex items-center gap-6">
                    <div className="w-20 h-20 rounded-[2.5rem] bg-rose-600 flex items-center justify-center shadow-2xl border-4 border-white">
                        <i className="pi pi-exclamation-triangle text-white text-3xl" />
                    </div>
                    <div>
                        <h1 className="text-3xl md:text-4xl font-black text-slate-900 leading-none uppercase tracking-tighter">Kritik Stok Yönetimi</h1>
                        <p className="text-slate-600 font-bold text-xs uppercase tracking-[0.1em] mt-3 italic flex items-center gap-2">
                             İş Sürekliliği ve Envanter Planlama
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-4">
                    <div className="bg-white p-5 rounded-[2rem] border border-slate-100 shadow-indigo-200 shadow-md flex items-center gap-4">
                        <div className="w-12 h-12 rounded-2xl bg-rose-50 text-rose-600 flex items-center justify-center">
                            <i className="pi pi-chart-bar text-xl" />
                        </div>
                        <div>
                            <p className="text-[12px] font-black text-slate-600 uppercase tracking-widest m-0">Kritik Ürün</p>
                            </div>
                            <div>
                                <h4 className="text-xl font-black text-slate-900 m-0">{data.length}</h4>
                            </div>
                           
                        
                    </div>
                    <Button icon="pi pi-refresh" onClick={fetchData} loading={loading} className="p-button-rounded p-button-outlined p-button-secondary w-16 h-16 border-2" />
                </div>
            </div>

            <div className="bg-white shadow-2xl shadow-slate-200/50 border border-slate-100 rounded-[3rem] overflow-hidden">
                <DataTable
                    value={data}
                    loading={loading}
                    header={header}
                    paginator
                    showGridlines 
                    rows={10}
                    className="p-datatable-sm" 
                    emptyMessage="Harika! Şu an kritik stokta ürününüz bulunmuyor."
                    rowHover
                    selectionMode="single"
                    selection={selectedProduct}
                    filters={filters}
                    onFilter={(e) => setFilters(e.filters)}
                    onSelectionChange={(e) => setSelectedProduct(e.value)}
                    header={renderHeader()}
                    dataKey="id"
                >
                    <Column field="productName" header="ÜRÜN ADI" body={(r) => (
                        <div className="flex flex-col py-2">
                            <span className="font-black text-slate-800 text-sm">{r.productName}</span>
                            <span className="text-[10px] text-slate-400 font-bold uppercase">{r.barcode || 'Barkodsuz'}</span>
                        </div>
                    )} sortable headerClassName="bg-transparent text-slate-700 font-black text-[14px] uppercase p-3 tracking-widest" className="p-4" />

                    <Column field="categoryName" header="KATEGORİ" body={(r) => <Tag value={r.categoryName} className="bg-slate-100 text-slate-600 font-bold text-[14px] px-3 py-1 rounded-full" />} sortable headerClassName="bg-transparent text-slate-700 font-black text-[14px] uppercase p-3 tracking-widest" className="p-4" />

                    <Column field="stockQuantity" header="MEVCUT DURUM" body={stockBodyTemplate} sortable headerClassName="bg-transparent text-slate-700 font-black text-[14px] uppercase p-3 tracking-widest" className="p-4" style={{ width: '250px' }} />

                    <Column field="salePrice" header="SATIŞ FİYATI" body={(r) => <span className="font-black text-slate-700">{r.salePrice.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</span>} sortable headerClassName="bg-transparent text-slate-700 font-black text-[14px] uppercase p-4 tracking-widest text-center" className="p-4 text-center" />

                    <Column body={actionTemplate} headerClassName="bg-transparent text-slate-700 font-black text-[14px] uppercase p-3 tracking-widest" className="p-4" />
                </DataTable>
            </div>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-emerald-900 rounded-[2.5rem] p-8 text-white relative overflow-hidden group">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 blur-2xl group-hover:scale-150 transition-all duration-700" />
                    <h4 className="text-xs font-black text-emerald-400 uppercase tracking-[0.3em] mb-4">Proaktif Satın Alma</h4>
                    <p className="text-sm font-medium text-emerald-100/70 leading-relaxed mb-6">Kritik stok seviyesindeki ürünleriniz için otomatik sipariş listesi oluşturabilir, tedarikçilerinize tek tıkla gönderebilirsiniz.</p>
                    <Button
                        label="Satın Alma Oluştur"
                        className="p-button-text text-white font-black text-xs p-0 hover:translate-x-2 transition-transform"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        onClick={() => handlePurchaseNavigate(selectedProduct)}
                        disabled={!selectedProduct}
                    />
                </div>
            </div>
        </div>
    );
}
